import React from 'react'
import styled from 'styled-components'

import Field from '../../../../../../../1stlog-ui/src/components/Field'
import Select from '../../../../../../../1stlog-ui/src/components/Select'

const Wrapper = styled.div`
  flex: 3 1 0;
  margin-left: 10px;
`

const TunnelLimitation = (props) => {
  const {} = props

  const options = [
    {
      value: null,
      label: i18n.t('label_none', 'Keine'),
    },
    {
      value: 'B',
      label: 'B',
    },
    {
      value: 'B1000C',
      label: 'B1000C',
    },
    {
      value: 'C',
      label: 'C',
    },
    {
      value: 'B/D',
      label: 'B/D',
    },
    {
      value: 'C5000D',
      label: 'C5000D',
    },
    {
      value: 'C/D',
      label: 'C/D',
    },
    {
      value: 'D',
      label: 'D',
    },
    {
      value: 'C/E',
      label: 'C/E',
    },
    {
      value: 'D/E',
      label: 'D/E',
    },
    {
      value: 'E',
      label: 'E',
    },
  ]

  return (
    <Wrapper>
      <Field
        name="tunnelLimitation"
        label={i18n.t('label_abk_tunnel_limit', 'TL')}
        tooltip={i18n.t('tunnel_limitation', 'Tunnellimitierung')}
        clearable={false}
        searchable
      >
        <Select
          options={options}
          direct
          placeholder={i18n.t('label_none', 'Keine')}
        />
      </Field>
    </Wrapper>
  )
}

export default TunnelLimitation
